import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  // Use useLayoutEffect to scroll before browser paints
  useLayoutEffect(() => {
    // Temporarily disable smooth scrolling for programmatic navigation
    const html = document.documentElement;
    const originalScrollBehavior = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';

    // Scroll to top immediately
    window.scrollTo(0, 0);

    // Restore scroll behavior after a frame
    requestAnimationFrame(() => {
      html.style.scrollBehavior = originalScrollBehavior;
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
